import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";
import { ReviewTab } from "src/config/reviewSystemData";
import classNames from "src/helpers/classNames";

interface ReviewStepTabsProps {
  reviewTabs: ReviewTab[];
  setReviewStep: Dispatch<SetStateAction<number>>;
}

const ReviewStepTabs = ({ reviewTabs, setReviewStep }: ReviewStepTabsProps) => {
  const t = useTranslations("ReviewForm");

  const handleTabClick = (tab: ReviewTab) => {
    if (tab.touched) {
      setReviewStep(tab.step);
    }
  };

  return (
    <nav
      className="isolate flex divide-x divide-gray-600 border border-gray-600 shadow"
      aria-label="Tabs"
    >
      {reviewTabs.map((tab) => (
        <button
          key={tab.name}
          onClick={() => handleTabClick(tab)}
          className={classNames(
            tab.current
              ? "!bg-beige-600"
              : tab.touched
              ? "!bg-beige-400 hover:!bg-beige-600"
              : "cursor-default",
            "group relative min-w-0 flex-1 overflow-hidden p-1 text-center text-sm font-medium transition-all duration-200 ease-in-out focus:z-10"
          )}
        >
          {tab.current && (
            <span className="text-xxs font-semibold lg:text-sm">
              {t(tab.name)}
            </span>
          )}
        </button>
      ))}
    </nav>
  );
};

export default ReviewStepTabs;
